import { Component, uiElement } from "@kluntje/core";
import { renderTemplate } from "Helper/renderHelper/renderTemplate";
import AnnouncementService from "Services/AnnouncementService";
export class SDEAnnouncementList extends Component {
  @uiElement(".sde-m-announcement-list__items")
  private itemsBox: HTMLDivElement;

  protected afterComponentRender(): void {
    this.init();
  }

  private async init() {
    const curAnnouncements = await AnnouncementService.getCurrentAnnouncements();

    if (
      curAnnouncements.public_announcements.length === 0 &&
      curAnnouncements.building_plan_announcements.length === 0
    ) {
      this.renderEmptyMessage();
      return;
    }

    const { renderItems } = await import("./sde-m-announcement-list.template");
    renderTemplate(renderItems(curAnnouncements), this.itemsBox, { clearSSRContent: true });
  }

  private async renderEmptyMessage() {
    const { renderEmptyMessage } = await import("./sde-m-announcement-list.template");
    renderTemplate(renderEmptyMessage(), this.itemsBox, { clearSSRContent: true });
  }
}

customElements.define("sde-m-announcement-list", SDEAnnouncementList);
